import React, { useEffect, useState } from 'react'
import { getCities } from 'redux/slices/cities'
import { retrieveCities } from 'redux/slices/cities/thunks'
import { getPaymentMethods, removePaymentMethod, retrievePaymentMethods } from 'redux/slices/payment'
import { getUserError, updateUser, clearSuccess, getUserSuccess } from 'redux/slices/user'
import { retrieveAllUserPasses } from 'redux/slices/passes/thunks'
import { getUserPasses } from 'redux/slices/passes'
import { useAuthenticatedState } from 'libs/web-client/utils/auth0/src'

import PassList from 'components/user-settings/PassList/PassList'
import Payment from 'components/user-settings/payment/Payment'
import Profile from './profile/Profile'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useStyles } from './styles'

const CadenzaTab = props => {
    const classes = useStyles()

    return (
        <Tab
            classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
                wrapper: classes.tabWrapper,
            }}
            {...props}
        />
    )
}

const tabs = [props => <Profile {...props} />, props => <Payment {...props} />, props => <PassList {...props} />]

export const UserSettings = ({
    cities,
    retrieveCities,
    updateUser,
    userError,
    clearSuccess,
    paymentMethods,
    userSuccess,
    retrievePasses,
    passes,
    removePaymentMethod,
    retrievePaymentMethods,
}) => {
    const { isAuthenticated, user } = useAuthenticatedState()

    const [tabIndex, setTabIndex] = useState(0)

    useEffect(() => {
        if (isAuthenticated) {
            retrievePaymentMethods()
            retrievePasses()
        }
    }, [retrievePasses, retrievePaymentMethods, isAuthenticated])

    const updateUserProfile = newUser => {
        updateUser(newUser, user)
        setTimeout(clearSuccess, 3000)
    }
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div className={classes.title}>My Account</div>
            <Tabs
                classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                value={tabIndex}
                onChange={(e, newValue) => setTabIndex(newValue)}
            >
                <CadenzaTab label="Profile" />
                <CadenzaTab label="Payment" />
                <CadenzaTab label="Show Passes" />
            </Tabs>
            {isAuthenticated &&
                tabs[tabIndex]({
                    cities,
                    retrieveCities,
                    updateUserProfile,
                    user,
                    userError,
                    removePaymentMethod,
                    passes,
                    paymentMethods,
                    userSuccess,
                })}
        </div>
    )
}

const mapStateToProps = state => ({
    userError: getUserError(state),
    cities: getCities(state),
    paymentMethods: getPaymentMethods(state),
    passes: getUserPasses(state),
    userSuccess: getUserSuccess(state),
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            retrieveCities,
            updateUser,
            clearSuccess,
            removePaymentMethod,
            retrievePaymentMethods,
            retrievePasses: retrieveAllUserPasses,
        },
        dispatch,
    )

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings)
